<template >
  <div >
    <el-card
        v-if="ready"
        style="padding: 20px" >
      <el-row
          slot="header"
          type="flex" >
        <el-col >
          <ctk-dater
              range
              default="thisyear"
              v-model="bookingRange"
              display-format="dd/MM/yyyy"
              export-format="DD/MM/YYYY" ></ctk-dater >
        </el-col >
        <el-col >
          <sf-button
              v-if="!totalData"
              @click="download"
              type="warning" >Create Download
          </sf-button >
        </el-col >


      </el-row >
      <el-card >

      </el-card >
      <q-card
          v-if="progressMessages"
          class="my-card text-white"
          style="background: radial-gradient(circle, #35a2ff 0%, #014a88 100%);width: 90%" >
        <q-card-section >
          <h4
              class="text-h4"
              v-html="progressMessages" ></h4 >
          <div
              class="text-subtitle2"
              v-if="totalData" >
            <h2 >{{ $theMoney(progress, 0, ',', '.') }}
              <small >/{{ $theMoney(totalData, 0, ',', '.') }}</small >
              <sf-button
                  confirm="Are you sure?"
                  @click="stopProgress=true" >Stop the process
              </sf-button >
            </h2 >
          </div >
        </q-card-section >

        <q-card-section
            class="q-pt-none"
            v-if="totalData" >
          <q-range
              v-model="progressBar"
              color="secondary"
              :min="0"
              :max="100"
              readonly />
        </q-card-section >
      </q-card >

      <el-row >
        <el-checkbox
            v-if="deleteAlsoA"
            v-model="deleteAlso" >Are you sure you want this...
        </el-checkbox >
      </el-row >
      <el-row v-if="dowloadLinks" >
        <div
            v-for="(dl,k) in dowloadLinks"
            :key="k" >
          <a
              :href="dl" >Click to download file {{ k + 1 }}
          </a >
        </div >
        <sf-button
            confirm="Are you crazy?"
            @click="goDelete" >Delete the data from DB
        </sf-button >
      </el-row >
    </el-card >

    <h5 v-else ><br /><br /><br />loading...</h5 >
  </div >
</template >

<script >
import _ from "lodash";
import * as api from "~/api/resource";
import {mapActions, mapGetters} from "vuex";
import {fetchProcessor} from "../../../api/resource";

export default {

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    customReq: {
      type: Object,
      default: () => null,
    },
    contactData: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      nots: null,
      ready: false,
      totalData: 0,
      progressMessages: null,
      progress: 0,
      waypoints: [],
      stopProgress: false,
      progressBar: {
        min: 0,
        max: 0
      },
      deleteAlso: false,
      deleteAlsoA: false,
      dowloadLinks: null,
      // bookingRange: null,
      userProfile: UserProfile,
      dateFormat: "DD/MM/YY",
    };
  },
  watch: {
    // transactions: {
    //   handler(val) {
    //     _log_(">>Q>>>",val, this.qTransactions);
    //     if (val && val.length) {
    //       const vm = this;
    //       vm.$emit("transctionsChanged", vm.transactions);
    //     }
    //   },
    //   deep: true
    // },
    async "contactData.id"(val, oldvl) {
      if (val == oldvl) return;
      const vm = this;
    },
    // async businessId(newVal, oldVal) {
    //   if (newVal != oldVal) {
    //     var { data } = await api.fetchProcessor("business/get", {
    //       objectId: this.invoiceData.businessId
    //     });
    //     this.businessData = data.object;
    //     // this.selectedBusiness = JSON.parse(JSON.stringify(data.object));
    //   }
    // }
  },
  // computed: {
  //   qNotifications() {
  //     // _log_(">>> this.customReq.id>>", this.customReq);
  //     if (this.customReq) return this.customReq;
  //     _log_(">>>contactData.id>>", this.contactData.id);
  //     return {contact_id: this.contactData.id};
  //   },
  //   colDefinitions() {
  //     const vm = this;
  //
  //     return [
  //       {
  //         prop: "timeSent",
  //         width: "120px",
  //
  //         label: "Αποστολή",
  //         formatter(val, colDefs, row) {
  //           return val > 100 ? vm.formatUnxTime(val) : null;
  //         },
  //       },
  //       {
  //         prop: "timeInteracted",
  //         width: "120px",
  //
  //         label: "Το είδε",
  //         formatter(val, colDefs, row) {
  //           return val > 100 ? vm.formatUnxTime(val) : null;
  //         },
  //       },
  //       {
  //         prop: "route_flight",
  //         width: "120px",
  //         formatter(val, colDefs, row) {
  //           if (!val) return;
  //           return (row.route_details ? row.route_details + ":" : "") + val;
  //         },
  //         label: "Δρομολογιο",
  //       },
  //       {
  //         prop: "route_date",
  //         width: "120px",
  //         formatter(val, colDefs, row) {
  //           if (!val) return;
  //           return (
  //               vm.formatUnxTime(val, false, true) +
  //               ":" +
  //               vm.intToTime(row.route_startTimeMM)
  //           );
  //         },
  //         label: "Ημρ.Δρλ.",
  //       },
  //       {
  //         prop: "message",
  //         width: "",
  //
  //         label: "Μήνυμα",
  //         formatter(val, colDefs, row) {
  //           return val;
  //         },
  //       },
  //     ];
  //   },
  //   ...mapGetters({
  //     transactionConfiguration: "user/transactionConfiguration",
  //   }),
  // },
  mounted() {
    this.ready = true;
  },
  methods: {
    async goDelete() {
      this.progressMessages = 'god save the queen'
      let q = {
        daterange: this.bookingRange,

        do: 'delete',

      };
      //get count
      const {data} = await api.fetchProcessor('waypoints/getlist', q)
      this.progressMessages = 'done'
    },
    async download() {
      this.progressMessages = 'Lets see what we have to do'
      this.progressBar.max = 0
      this.totalData = 0
      this.progress = 0
      this.dowloadLinks = null
      let q = {
        daterange: this.bookingRange,

        do: 'count',

      };
      //get count
      const {data} = await api.fetchProcessor('waypoints/getlist', q)
      const limit = 50000
      q.limit = limit
      let timePred = 2.100;
      if (data && data.total) {
        this.totalData = data.total

        let counter = 0, tm = '', tmL = ''


        let filepath = null
        let lastCounter = 1;
        for (let i = 0; i < this.totalData; i += limit) {
          const clockA = new Date(), tA = clockA.getTime()/1000;

          q.do = 'export'
          this.progress = q.offset = i
          this.progressBar.max = parseInt(100 * i / this.totalData)
          const {data} = await api.fetchProcessor('waypoints/getlist', q)
          lastCounter = data.lastCounter
          // const stratsNow = clock.getTime()
          filepath = data.filepath




          let estMinutes = Math.floor((timePred * this.totalData / limit)/ 60)
          if (estMinutes > 60) {
            tm = (Math.floor(estMinutes / 60)) + ' hours and ' + (estMinutes % 60) + ' minutes'
          }
          else tm = estMinutes + ' minutes '
          let estMinutesLeft = Math.floor(((timePred * ((this.totalData - i) / limit)) ) / 60)
          if (estMinutesLeft > 60) {
            tmL = (Math.floor(estMinutesLeft / 60)) + ' hours and ' + (estMinutesLeft % 60) + ' minutes'
          }
          else tmL = estMinutesLeft + ' minutes '
          const clockZ = new Date();
          const tDf = tA - clockZ.getTime()/1000;
          timePred = Math.abs(Math.floor((timePred + tDf) / 2))
          this.progressMessages = '<small>Preparing the CSV export, (raff) estimated time </small>' + tmL + ' / ' + tm
          if (this.stopProgress) {
            this.stopProgress = false
            break;
          }
        }
        this.progressBar.max = 100
        this.totalData = 0
        filepath = '/assets/' + filepath
        let links = []
        for (let i = 1; i <= lastCounter; i++)
          links.push(filepath + (i.toString()) + '.csv')


        this.dowloadLinks = links
        _log_('data...to', filepath, this.dowloadLinks, lastCounter)

      }
      else {
        this.progressMessages = 'Nothing to do'

      }
      _log_('ways,,', data)
    },

  },
};
</script >
